// Copyright 2016 Sorama B.V.

import { IIndexableObject } from "libraries/IndexedDb/IIndexableObject";

export class OfflineCreditsTransaction implements IIndexableObject {
    id: string;
    userId: string;

    previousTransactionId: string;

    tokenId: string;
    protectedContent: string;
}
